import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import ScrollReveal from '../components/shared/ScrollReveal'
import GradientText from '../components/shared/GradientText'
import GlowButton from '../components/shared/GlowButton'
import { Icons } from '../components/shared/Icons'
import './DraftPages.css'

export default function PaymentCancel() {
  return (
    <div className="draft-page">
      <section className="draft-hero payment-result-section">
        <div className="container">
          <ScrollReveal>
            <motion.div
              className="payment-result-card cancelled"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <div className="result-icon cancelled">
                <Icons.x size={48} />
              </div>

              <h1 className="result-title">
                Payment <GradientText gradient="solar">Cancelled</GradientText>
              </h1>

              <p className="result-subtitle">
                Your payment was not completed. No charges have been made to your account.
              </p>

              <div className="cancelled-info">
                <p>This could have happened because:</p>
                <ul>
                  <li>You chose to cancel the payment</li>
                  <li>The session timed out</li>
                  <li>There was an issue with the payment method</li>
                </ul>
              </div>

              <div className="result-actions">
                <GlowButton variant="solar" href="/register">
                  <Icons.refresh size={20} />
                  Try Again
                </GlowButton>
                <GlowButton variant="outline" href="/pricing">
                  View Plans
                </GlowButton>
              </div>

              <p className="result-footer">
                Need help? Contact our support team at{' '}
                <a href="mailto:support@ai4solar.com">support@ai4solar.com</a>
              </p>
            </motion.div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  )
}
